import Cookies from "js-cookie"
import PropTypes from "prop-types"
import React, { PureComponent } from "react"

import styles from "./Alert.module.css"

class Alert extends PureComponent {
  static propTypes = {
    /** Alert content. Text or HTML. */
    children: PropTypes.node.isRequired,
    /** Custom class. */
    className: PropTypes.string,
    /** Type of alert. Changes color. */
    type: PropTypes.string,
    /** Display close button or not. */
    canClose: PropTypes.bool,
    /** Custom id, String will be used as cookie name. */
    id(props, propName) {
      if (
        props.canClose === true &&
        (props[propName] === "" || typeof props[propName] !== "string")
      ) {
        return new Error("Failed prop type: Please provide an id string!")
      }
      return undefined
    },
    /** Date object, or number of days until cookie expiration. Default - null, the cookie stays until it's deleted */
    expires: PropTypes.oneOfType([PropTypes.object, PropTypes.number]),
  }

  static defaultProps = {
    className: "",
    type: "success",
    canClose: null,
    id: "",
    expires: null,
  }

  constructor(props) {
    super(props)

    const isCookieSet = !!Cookies.get(`alert-${props.id}`)

    this.state = {
      show: props.canClose ? !isCookieSet : true,
    }

    this.hide = this.hide.bind(this)
  }

  hide() {
    const { id, expires } = this.props
    Cookies.set(`alert-${id}`, true, { path: "/", expires })
    this.setState({
      show: false,
    })
  }

  render() {
    const { children, type, canClose, className, id, ...rest } = this.props
    const { show } = this.state
    return show ? (
      <div
        id={id}
        className={[styles.root, styles[type], className].join(" ")}
        {...rest}
      >
        {canClose && (
          <button onClick={this.hide} className={styles.canClose} type="button">
            <span className="icon-close" />
          </button>
        )}
        {children}
      </div>
    ) : null
  }
}

export default Alert
